import { RouteType } from "../../../types/RouteType";

const customBOMRoute: RouteType = {
  name: "Custom BOM",
  path: "/qc/custom-bom",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./CustomBOM.Header"),
      title: "Custom BOM Entry",
      color: "primary",
    },
    body: {
      component: () => import("./CustomBOM.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false,

  beforeEnter: async () => {
    return true;
  },

  dialogs: [],
};

export default customBOMRoute;
